<template>
  <sui-grid :columns="columns" centered>
      <sui-grid-column stretched textAlign= "center" v-for="size in sizes" :key="size.id">
        <sui-segment  v-if="size.empty>0" compact :id="size.id" @click="selectItem(size)">
          <a is="sui-label" class="floating" color="grey">{{ size.empty }}</a>
          {{ size.text }} <br>
          {{ size.dim }}
        </sui-segment>
        <sui-segment  v-else class="disabled" compact>
          <a is="sui-label" class="floating" color="grey">{{ size.empty }}</a>
          {{ size.text }} <br>
          {{ size.dim }}
        </sui-segment>
      </sui-grid-column>
    </sui-grid>
</template>

<script>
export default {
  props: ['theSizes', 'defaultSelected'],
  data() {
      return {
        columns: null,
        sizes: [],
        selected: null
      }
  },
  mounted() {
    this.initializeComponent(this.theSizes);
  },
  updated() {
    //console.log('En updated')
    // if (this.selected == null && this.defaultSelected) {
    //   this.selectItem(this.defaultSelected);
    // }
    if (this.defaultSelected) {
      this.selectItem(this.defaultSelected);
    }
     
  },
  // watch: {
  //   'theSizes': function(new_theSizes, old_theSizes) {
  //     console.log('En watch')
    
  //     this.initializeComponent(new_theSizes);
  //   }
  // },
  methods: {
    initializeComponent(sizes) {
      this.columns = this.theSizes.length;
      this.sizes = [... this.theSizes];
      //this.selectItem(this.sizes.find((a) => a.empty > 0))
    },
    selectItem(theItem) {
      let index = null;
      //if (theItem.id === this.selected || theItem.empty === 0) return;
      if (theItem.id === this.selected) return;
      

      // if (this.selected !== null) {
      //   index = this.sizes.findIndex((e) => (e.id === this.selected));
      //   this.sizes[index].empty += 1;
      // }

      //this.parcelInfo.slot_size = size;
      let elems = document.getElementsByClassName('segment')
      for (var i = 0; i < elems.length; i++) {
        elems[i].classList.remove('tertiary');
      }
      
      index = this.sizes.findIndex((e) => (e.id === theItem.id));
      //this.sizes[index].empty -= 1;
      document.getElementById(theItem.id).classList.add('tertiary');
      
      this.selected = theItem.id;
      this.$emit('on-size-selected', {'id': theItem.id, 'text':theItem.text});
    }
    
  }
}
</script>
<style>

</style>


// WEBPACK FOOTER //
// src/components/sizeModule.vue